const REQUIRED_ERROR_MESSAGE = "Required";
const isEmptyInput = (input) => input === undefined ||
    input === null ||
    input === "" ||
    (typeof input === "number" && Number.isNaN(input)) ||
    (Array.isArray(input) && input.length === 0);
const requiredOr = (message) => (issue) => isEmptyInput(issue.input) ? REQUIRED_ERROR_MESSAGE : message;

export { REQUIRED_ERROR_MESSAGE, isEmptyInput, requiredOr };
